import MerchantDashboard from '@/components/merchants/Dashboard'
import MerchantAccount from '@/components/merchants/account/Account'
import MerchantPayments from '@/components/merchants/Payments'
import MerchantNpos from '@/components/merchants/Npos'
import MerchantPos from '@/components/merchants/POS'
import MerchantDonations from '@/components/merchants/DonationFee'
// import MerchantFees from '@/components/merchants/DonappFee'
import MerchantHelp from '@/components/merchants/Help'
import MerchantPaymentDetails from '@/components/merchants/PaymentDetails'
import MerchantDonationDetails from '@/components/merchants/DonationFeeDetails'

export default [
  {
    path: '/merchants/dashboard',
    name: 'MerchantDashboard',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-dev', 'merchant-accountant']
    },
    component: MerchantDashboard
  },
  {
    path: '/merchants/account',
    name: 'MerchantProfile',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-dev', 'merchant-accountant']
    },
    component: MerchantAccount
  },
  {
    path: '/merchants/payments',
    name: 'MerchantPayments',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-accountant']
    },
    component: MerchantPayments
  },
  {
    path: '/merchants/payments/:id',
    props: true,
    name: 'MerchantPaymentDetails',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-accountant']
    },
    component: MerchantPaymentDetails
  },
  {
    path: '/merchants/donations',
    name: 'MerchantDonations',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-accountant']
    },
    component: MerchantDonations
  },
  {
    path: '/merchants/donations/:id',
    name: 'MerchantDonationDetails',
    props: true,
    meta: {
      accessLevels: ['merchant-admin', 'merchant-accountant']
    },
    component: MerchantDonationDetails
  },
  {
    path: '/merchants/npos',
    name: 'MerchantNpos',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-dev', 'merchant-accountant']
    },
    component: MerchantNpos
  },
  // {
  //   path: '/merchants/fees',
  //   name: 'MerchantFees',
  //   meta: {
  //     accessLevels: ['merchant-admin', 'merchant-accountant']
  //   },
  //   component: MerchantFees
  // },
  {
    path: '/merchants/pos',
    name: 'MerchantPos',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-dev', 'merchant-accountant']
    },
    component: MerchantPos
  },
  {
    path: '/merchants/help',
    name: 'MerchantHelp',
    meta: {
      accessLevels: ['merchant-admin', 'merchant-dev', 'merchant-accountant']
    },
    component: MerchantHelp
  }
]



// WEBPACK FOOTER //
// ./src/router/merchant.js